export const environment = {
    production: false,
    apiUrl: 'https://api.meteeaunappes.brgm.fr',
    wfsBaseUrl: 'https://app.meteeaunappes.brgm.fr/wfs', // The /geoserver suffix is added to be compatible with the current codebase, but it can be removed if the codebase is updated to use the base URL directly
    hubeauBase: 'https://hubeau.eaufrance.fr/api',
    keycloak: { 
        realm: 'BRGM',
        clientId: 'meteeaunappes',
        url: 'https://auth.brgm.fr'
    }
};